import { Lock } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { VENUE_TYPES } from "@/lib/venues";

export function VenueModules({ form, setForm, featureInfo, onChanged }) {
  if (!featureInfo) return null;
  const hidden = form.hidden_modules || [];
  const chooseVenue = async (vt) => {
    try {
      const { data } = await api.post("/business/venue-type", { venue_type: vt });
      setForm({ ...form, venue_type: data.venue_type, hidden_modules: data.hidden_modules });
      onChanged(data);
      toast.success("Modules set up for your venue type");
    } catch { toast.error("Could not change venue type"); }
  };
  const toggle = (k, on) => setForm({ ...form, hidden_modules: on ? hidden.filter((h) => h !== k) : [...hidden, k] });

  return (
    <div className="bg-card border border-border rounded-md p-6 space-y-4" data-testid="venue-modules">
      <div>
        <h3 className="font-serif text-lg text-foreground">Venue type &amp; modules</h3>
        <p className="text-xs text-muted-foreground">Choosing a venue type applies its modules straight away; fine-tune the switches below, then click Save.</p>
      </div>
      <div>
        <Label>Venue type</Label>
        <Select value={form.venue_type || ""} onValueChange={chooseVenue}>
          <SelectTrigger className="mt-1.5" data-testid="venue-type-select"><SelectValue placeholder="Choose your venue type" /></SelectTrigger>
          <SelectContent>{VENUE_TYPES.map((v) => <SelectItem key={v.id} value={v.id} data-testid={`venue-type-${v.id}`}>{v.label}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="grid sm:grid-cols-2 gap-x-6 gap-y-2.5">
        {Object.entries(featureInfo.labels).map(([k, label]) => {
          const inPlan = !!featureInfo.features[k];
          return (
            <div key={k} className="flex items-center justify-between gap-3" data-testid={`module-row-${k}`}>
              <span className={`text-sm ${inPlan ? "text-foreground" : "text-muted-foreground"}`}>{label}</span>
              {inPlan ? <Switch checked={!hidden.includes(k)} onCheckedChange={(v) => toggle(k, v)} data-testid={`module-toggle-${k}`} />
                : <span className="flex items-center gap-1 text-[10px] uppercase tracking-widest text-muted-foreground"><Lock className="w-3 h-3" /> Upgrade</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
